
import { Fragment } from "react";
import { Icon, Table, Td, Th, Tr } from "@usas/ui-web/components/table/Table";
import { SORT_TYPES } from "@usas/ui-web/components/table/utils/TableConstants";
import { formatDate } from '@usas/ui-web/utils/DateFunctions'

import useTouchpointsGrid from "./UseTouchpointsGrid";

const LSCTouchpointsGrid = ({ data, isLoading, onEditClicked, onDeleteClicked }) => {
  const {
    gridState
  } = useTouchpointsGrid(data);

  return (
    <Fragment>
      <Table.ContextWrapper data={gridState.gridData} rowIdKey={'lscTouchpointId'} >
        <Table.Large>
          <thead>
            <Tr.Top colSpan={7} showDataTotal={isLoading !== true} dataName='Touchpoint' dataTotal={data.length}>
            </Tr.Top>
            <tr>
              <Th.Sort sortKey={'touchpointDate'} sortType={SORT_TYPES.DATE}>Date</Th.Sort>
              <Th.Sort sortKey={'touchpointTypeName'} sortType={SORT_TYPES.ALPHABETICAL}>Type</Th.Sort>
              <Th.Sort sortKey={'subjectName'} sortType={SORT_TYPES.ALPHABETICAL}>Subject</Th.Sort>
              <Th.Sort sortKey={'touchpointNote'} sortType={SORT_TYPES.ALPHABETICAL}>Note</Th.Sort>
              <Th.Sort sortKey={'enteredByLastName'} sortType={SORT_TYPES.ALPHABETICAL}>Entered By</Th.Sort>
              <Th.Sort sortKey={'followUpDate'} sortType={SORT_TYPES.DATE}>Followup Date</Th.Sort>
              <Th.Action></Th.Action>
            </tr>
          </thead>
          <Table.Body colSpan={7} isLoading={isLoading} noDataText='No LSC Touchpoints'
            renderRow={(touchpoint, i) =>
              <tr key={i}>
                <td>{formatDate(touchpoint.touchpointDate)}</td>
                <td>{touchpoint.touchpointTypeName}</td>
                <td>{touchpoint.subjectName}</td>
                <td style={{width: '450px', lineHeight: '1.5'}}>{touchpoint.touchpointNote}</td>
                <td>{touchpoint.enteredByFirstName} {touchpoint.enteredByLastName}</td>
                <td>{formatDate(touchpoint.followUpDate) === '00/00/0000' ? '' : formatDate(touchpoint.followUpDate)}</td>
                <Td.Action>
                  <Icon.Edit onClick={(e) => onEditClicked(e, touchpoint)} />
                  {onDeleteClicked &&
                    <Icon.Delete onClick={(e) => onDeleteClicked(e, touchpoint.lscTouchpointId)} />
                  }
                </Td.Action>
              </tr>
            } />
        </Table.Large>
        <Table.Small>
          <thead>
            <Tr.Top colSpan={7} showDataTotal={isLoading !== true} dataName='Touchpoint' dataTotal={data.length}></Tr.Top>
            <tr>
              <Th.Sort sortKey={'touchpointTypeName'} sortType={SORT_TYPES.ALPHABETICAL}>Type</Th.Sort>
              <Th.Sort sortKey={'subjectName'} sortType={SORT_TYPES.ALPHABETICAL}>Subject</Th.Sort>
              <Th.Sort sortKey={'touchpointNote'} sortType={SORT_TYPES.ALPHABETICAL}>Note</Th.Sort>
              <Th.Sort sortKey={'touchpointDate'} sortType={SORT_TYPES.DATE}>Date</Th.Sort>
              <Th.Sort sortKey={'enteredByLastName'} sortType={SORT_TYPES.ALPHABETICAL}>Entered By</Th.Sort>
              <Th.Sort sortKey={'followUpDate'} sortType={SORT_TYPES.DATE}>Followup Date</Th.Sort>
              <Th.Action></Th.Action>
            </tr>
          </thead>
          <Table.Body colSpan={7} isLoading={isLoading} noDataText='No Club Staff'
            renderRow={(touchpoint, i) =>
              <tr key={i}>
                <td>{touchpoint.touchpointTypeName}</td>
                <td>{touchpoint.subjectName}</td>
                <td>{touchpoint.touchpointNote}</td>
                <td>{formatDate(touchpoint.touchpointDate)}</td>
                <td>{touchpoint.enteredByFirstName} {touchpoint.enteredByLastName}</td>
                <td>{formatDate(touchpoint.followUpDate) === '00/00/0000' ? '' : formatDate(touchpoint.followUpDate)}</td>
                <Td.Action>
                  <Icon.Edit onClick={(e) => onEditClicked(e, touchpoint)} />
                  {onDeleteClicked &&
                    <Icon.Delete onClick={(e) => onDeleteClicked(e, touchpoint.lscTouchpointId)} />
                  }
                </Td.Action>
              </tr>
            } />
        </Table.Small>
      </Table.ContextWrapper>
    </Fragment>
  );
};

export default LSCTouchpointsGrid;